'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = applyDefaults;

var _legacyHubspotBenderContext = require('legacy-hubspot-bender-context');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function applyDefaults(method, url, data) {
  data.query = _extends(_defineProperty({}, _legacyHubspotBenderContext.bender.project, _legacyHubspotBenderContext.bender.depVersions[_legacyHubspotBenderContext.bender.project]), data.query);
  return method(url, _extends({}, data));
}
module.exports = exports['default'];